<template>
  <div class="container">
    <div class="btn-open-filters" v-on:click="openListOfFilter()">
      <svg id="arrows-menu-filters" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.41 10.71">
        <line x1=".71" y1="2.85" x2="15.71" y2="2.85"
              style="fill:none; stroke:#000; stroke-miterlimit:10;"/>
        <polyline points="3.21 5.35 .71 2.85 3.21 .35" style="fill:none;
       stroke:#000; stroke-miterlimit:10;"/>
        <line x1="20.71" y1="7.85" x2="5.71" y2="7.85"
              style="fill:none; stroke:#000; stroke-miterlimit:10;"/>
        <polyline points="18.21 5.35 20.71 7.85 18.21 10.35"
                  style="fill:none; stroke:#000; stroke-miterlimit:10;"/>
      </svg>
      <span>Navegar / Filtrar</span>
    </div>

    <div v-if="showListOfFilters" class="list-of-all-filters">
      <div class="header">
        <div class="close-filter">
          <svg id="close-menu-filters" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.35 30.35"
               v-on:click="this.showListOfFilters = false;">
            <line x1=".18" y1=".18" x2="30.18" y2="30.18" fill="none" stroke="#fff" stroke-miterlimit="10"
                  stroke-width="2"/>
            <line x1="30.18" y1=".18" x2=".18" y2="30.18" fill="none" stroke="#fff" stroke-miterlimit="10"
                  stroke-width="2"/>
          </svg>
        </div><!--.close-filter-->

        <div class="values-of-filter" v-for="filter in filters">
          <span class="value-filter"
                v-for="value in filter['children']"
                :data-id="value.id"
                v-on:click="infoParentClick($event, value.id)">
        {{ value.name }}
        </span>
        </div><!--.values-of-filter-->

      </div><!--.header-->

      <div class="footer" v-on:click="this.showListOfFilters = false;">
         <span class="value-filter all-filters"
               data-id="all"
               v-on:click="infoParentClick($event, 'all')">
          Ver tudo
        </span>
        <span class="showFilters">Ver resultados</span>
      </div><!--.footer-->

    </div><!--.list-of-all-filters-->

    <div class="project-articles">
      <div class="info-project-category">
        <h1 class="title-category">{{ category.class }}</h1>
        <p class="description-category">{{ category.description }}</p>
      </div><!--.info-project-category-->
      <div class="articles-list"
           v-if="articles.length"
           v-for="item in articles">
        <a :href="item.slug">
          <img class="img-article" v-if="item.featured_image"
               :src="item.featured_image.mediaCollection['thumbnail_double_width']"
               :alt="item.featured_image.title">
          <img class="img-article" v-else src="/img/frontend_assets/no-image.png"
               :alt="category.title">
          <h1 class="title-article">{{ item.title }}</h1>

          <p class="excerpt-article" v-if="item.excerpt" v-html="item.excerpt"></p>
        </a>
      </div><!--.articles-list-->
    </div><!--.project-articles-->
  </div>
</template>

<script>
export default {
  props: {
    category: Object,
    filters: Object,
    articles: Object
  },
  data: function () {
    return {
      showListOfFilters: false
    }
  },
  methods: {
    openListOfFilter() {
      this.showListOfFilters = true;
    },
    infoParentClick(evt, id) {
      this.$parent.handleClickedFilters(evt, id);
    }
  },
}
</script>

<style scoped>

</style>
